import styled, { createGlobalStyle } from 'styled-components';

export const Container = styled.div`
    padding-top: 50px;
    padding-left: 90px;
    padding-right: 90px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;


// WEBPACK FOOTER //
// ./src/styled.js